
//Defines all the Order Status available in the app.
//IMPORTANT: Must be mapped to each specific order status keyword to work properly.
export enum OrderPaymentTypeValue {
  Offline = 'offline',
  Card = 'payment',
  Crypto = 'crypto',
  BankTransfer = 'transfer',
}
